<template>
	<div>
		<div class="data6">
			<div class="data6Left">
				<div class="data6LeftTil">
					图像处理·细节甄别
				</div>
				<div class="data6LeftBox">
					<div class="data6LeftFor" v-for="(item,index) in byzlList" :key="index">
						<div class="data6LeftForImg">
							<img :src="item.img" />
						</div>
						<div class="data6LeftForName">
							{{item.name}}
						</div>
						<div class="data6LeftForCen">
							{{item.cen}}
						</div>
					</div>
				</div>
			</div>
			<div class="data6Right">
				<img src="@/assets/product/page2/czjyZlys.png" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		data() {
			return {
				byzlList: [{
						img: require('@/assets/product/page8/txfd.png'),
						name: '图像放大',
						cen: '- 实现细节放大- 四档倍率可选'
					},
					{
						img: require('@/assets/product/page8/xhdbzq.png'),
						name: '血红蛋白增强',
						cen: '- 高显色、强对比- 增强病变组织可能形成的粘膜血管形态'
					},
					{
						img: require('@/assets/product/page8/jgqd.png'),
						name: '结构强调',
						cen: '- 强调图像的结构形态'
					},
					{
						img: require('@/assets/product/page8/lkqd.png'),
						name: '轮廓强调',
						cen: '- 强调图像的边缘及轮廓'
					},
				]
			}
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data6 {
		display: flex;
		padding-bottom: 150px;

		.data6Left {
			flex: 1;
			padding-left: 200px;

			.data6LeftTil {
				font-size: 45px;
				
				font-weight: bold;
				color: #000000;
				margin-bottom: 70px;
			}

			.data6LeftBox {
				display: flex;
				flex-wrap: wrap;
				width: 100%;

				.data6LeftFor {
					width: calc(49% - 40px);
					padding: 0 20px;
					margin-bottom: 70px;

					.data6LeftForImg {
						margin-bottom: 42px;

						img {
							width: 70px;
							height: 70px;
						}
					}

					.data6LeftForName {
						margin-bottom: 32px;
						font-size: 26px;
						
						font-weight: 400;
						color: #000000;
					}

					.data6LeftForCen {
						font-size: 18px;
						
						font-weight: 300;
						color: #000000;
					}
				}
			}
		}

		.data6Right {
			flex: 1;

			img {
				width: 100%;
				height: 600px;
				object-fit: cover;
			}
		}
	}
</style>